import { ref, computed } from 'vue'

const isCollapsed = ref(true)
const isMobile = ref(window.innerWidth <= 768)
const isLargeScreen = ref(window.innerWidth >= 1025)
const sidebarOpen = ref(false)

window.addEventListener('resize', () => {
  isMobile.value = window.innerWidth <= 768
  isLargeScreen.value = window.innerWidth >= 1025
  // Close sidebar on desktop
  if (!isMobile.value) {
    sidebarOpen.value = false
  }
})

export function useSidebar() {
  const sidebarWidth = computed(() => {
    if (isMobile.value) return 50
    return isLargeScreen.value ? 72 : 60
  })

  const toggleSidebar = () => {
    sidebarOpen.value = !sidebarOpen.value
  }

  const openSidebar = () => {
    sidebarOpen.value = true
  }

  const closeSidebar = () => {
    sidebarOpen.value = false
  }

  return {
    isCollapsed,
    sidebarWidth,
    isMobile,
    sidebarOpen,
    toggleSidebar,
    openSidebar,
    closeSidebar
  }
}